export default __webpack_public_path__ + "static/media/CR2.24401eaf.png";